module.exports = __webpack_public_path__ + "static/media/Noah.13b8fb26.png";